export function isWeaponRanged(weapTyp) {
	switch (weapTyp) {
		case 'Bow':
		case 'Musical':
		case 'Whip':
		case 'Revolver':
		case 'Rifle':
		case 'Gatling':
		case 'Shotgun':
		case 'Grenade':
			return true
		default:
			return false
	}
}

export function isSkillRanged(SkillId, SkillLv) {
	/* TODO */
	switch (SkillId) {
		case 'SR_KNUCKLEARROW':
			return true
		default:
			return false
	}
}
const magicSkillList = [
	'MG_NAPALMBEAT',
	'MG_FIREBALL',
	'MG_SOULSTRIKE',
	'MG_FIREWALL',
	'MG_FIREBOLT',
	'MG_COLDBOLT',
	'MG_LIGHTNINGBOLT',
	'MG_THUNDERSTORM',
	'MG_FROSTDIVER',
	'AL_HOLYLIGHT',
	'AL_RUWACH',
	'WZ_FROSTNOVA',
	'WZ_FIREPILLAR',
	'WZ_SIGHTRASHER',
	'WZ_WATERBALL',
	'WZ_STORMGUST',
	'WZ_EARTHSPIKE',
	'HW_NAPALMVULCAN',
	'SL_STIN',
	'SL_STUN',
	'SL_SMA',
	'NJ_KOUENKA',
	'NJ_KAENSIN',
	'NJ_BAKUENRYU',
	'NJ_HYOUSENSOU',
	'NJ_HYOUSYOURAKU',
	'NJ_RAIGEKISAI',
	'NJ_KAMAITACHI',
	'NJ_HUUJIN',
	'NPC_ENERGYDRAIN',
	'WZ_HEAVENDRIVE',
	'NPC_GROUNDDRIVE',
	'WZ_METEOR',
	'WZ_VERMILION',
	'PR_MAGNUS',
	'BA_DISSONANCE',
	'HW_GRAVITATION',
	'PA_PRESSURE',
	'WZ_SIGHTBLASTER',
	'AB_JUDEX',
	'AB_ADORAMUS',
	'AB_DUPLELIGHT_MAGIC',
	'WL_SOULEXPANSION',
	'WL_FROSTMISTY',
	'NPC_JACKFROST',
	'WL_JACKFROST',
	'WL_DRAINLIFE',
	'WL_CRIMSONROCK',
	'WL_HELLINFERNO',
	'WL_COMET',
	'WL_CHAINLIGHTNING_ATK',
	'WL_EARTHSTRAIN',
	'WL_TETRAVORTEX_FIRE',
	'WL_TETRAVORTEX_WATER',
	'WL_TETRAVORTEX_WIND',
	'WL_TETRAVORTEX_GROUND',
	'WL_SUMMON_ATK_FIRE',
	'WL_SUMMON_ATK_WATER',
	'WL_SUMMON_ATK_WIND',
	'WL_SUMMON_ATK_GROUND',
	'LG_RAYOFGENESIS',
	'NPC_RAYOFGENESIS',
	'WM_METALICSOUND',
	'WM_REVERBERATION',
	'SO_FIREWALK',
	'SO_ELECTRICWALK',
	'NPC_FIREWALK',
	'NPC_ELECTRICWALK',
	'SO_EARTHGRAVE',
	'SO_DIAMONDDUST',
	'SO_POISON_BUSTER',
	'NPC_POISON_BUSTER',
	'SO_PSYCHIC_WAVE',
	'NPC_PSYCHIC_WAVE',
	'SO_CLOUD_KILL',
	'NPC_CLOUD_KILL',
	'SO_VARETYR_SPEAR',
	'GN_DEMONIC_FIRE',
	'KO_KAIHOU',
	'EL_FIRE_MANTLE',
	'EL_WATER_SCREW',
	'EL_FIRE_ARROW',
	'EL_ROCK_CRUSHER_ATK',
	'EL_FIRE_BOMB',
	'EL_ICE_NEEDLE',
	'EL_HURRICANE_ATK',
	'EL_FIRE_WAVE',
	'EL_TYPOON_MIS_ATK',
	'MH_ERASER_CUTTER',
	'MH_XENO_SLASHER',
	'MH_TWISTER_CUTTER',
	'MH_ABSOLUTE_ZEPHYR',
	'MH_HEILIGE_STANGE',
	'MH_HEILIGE_PFERD',
	'MH_POISON_MIST',
	'SU_SV_STEMSPEAR',
	'SU_CN_METEOR',
	'SU_CN_METEOR2',
	'NPC_VENOMFOG',
	'NPC_COMET',
	'NPC_FIRESTORM',
	'NPC_HELLBURNING',
	'NPC_PULSESTRIKE2',
	'SP_CURSEEXPLOSION',
	'SP_SPA',
	'SP_SHA',
	'SP_SWHOO',
	'NPC_STORMGUST2',
	'AG_DEADLY_PROJECTION',
	'AG_DESTRUCTIVE_HURRICANE',
	'AG_RAIN_OF_CRYSTAL',
	'AG_MYSTERY_ILLUSION',
	'AG_VIOLENT_QUAKE_ATK',
	'AG_SOUL_VC_STRIKE',
	'AG_STRANTUM_TREMOR',
	'AG_ALL_BLOOM_ATK',
	'AG_ALL_BLOOM_ATK2',
	'AG_CRYSTAL_IMPACT',
	'AG_CRYSTAL_IMPACT_ATK',
	'AG_TORNADO_STORM',
	'AG_FLORAL_FLARE_ROAD',
	'AG_ASTRAL_STRIKE',
	'AG_ASTRAL_STRIKE_ATK',
	'AG_ROCK_DOWN',
	'AG_STORM_CANNON',
	'AG_CRIMSON_ARROW',
	'AG_CRIMSON_ARROW_ATK',
	'AG_FROZEN_SLASH',
	'IG_JUDGEMENT_CROSS',
	'IG_CROSS_RAIN',
	'CD_ARBITRIUM',
	'CD_ARBITRIUM_ATK',
	'CD_PNEUMATICUS_PROCELLA',
	'CD_FRAMEN',
	'AG_DESTRUCTIVE_HURRICANE_CLIMAX',
	'ABC_ABYSS_STRIKE',
	'ABC_ABYSS_SQUARE',
	'TR_METALIC_FURY',
	'TR_SOUNDBLEND',
	'EM_DIAMOND_STORM',
	'EM_LIGHTNING_LAND',
	'EM_VENOM_SWAMP',
	'EM_CONFLAGRATION',
	'EM_TERRA_DRIVE',
	'ABC_FROM_THE_ABYSS_ATK',
	'EM_ELEMENTAL_BUSTER_FIRE',
	'EM_ELEMENTAL_BUSTER_WATER',
	'EM_ELEMENTAL_BUSTER_WIND',
	'EM_ELEMENTAL_BUSTER_GROUND',
	'EM_ELEMENTAL_BUSTER_POISON',
	'EM_EL_FLAMEROCK',
	'EM_EL_AGE_OF_ICE',
	'EM_EL_STORM_WIND',
	'EM_EL_AVALANCHE',
	'EM_EL_DEADLY_POISON',
	'NPC_RAINOFMETEOR',
]
export function isSkillMagic(SkillId) {
	return magicSkillList.includes(SkillId)
}

export function doesSkillUseMastery(SkillId, SkillLv) {
	/* TODO */
	switch (SkillId) {
		case 'MO_EXTREMITYFIST':
			return false
		default:
			return true
	}
}

export function getSkillDamageMultiplier(Bonuses, SkillName) {
	if (Bonuses?.bSkillAtk)
		return Bonuses?.bSkillAtk[SkillName] ? Bonuses?.bSkillAtk[SkillName] : 0
	return 0
}
